export default () => {
	const SelectDecorator = Component(
		function($context) {
			return $context.select('.js-select-decorator');
		},
		function($control) {
			Select.create(
				$control,
				$control.data('size'),
				$control.data('fill'),
				$control.data('classes'),
				$control.data('label')
			);
			$control.removeClass('js-select-decorator');
		}
	);

	window.ObserverUtil.observeComponent('js-select-decorator', SelectDecorator);

	return SelectDecorator;
};
